import React, { useState, useRef, useEffect } from "react";
import { Document, Page } from "react-pdf";

const RenderPDF = ({ file }) => {
    const [numPages, setNumPages] = useState(null);
    const [scale, setScale] = useState(1);
    const containerRef = useRef(null);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const updateScale = () => {
        const containerWidth = containerRef.current
            ? containerRef.current.clientWidth
            : 0;
        const desiredWidth = 800; // Adjust this to match the PDF's original width
        const newScale = containerWidth / desiredWidth;
        setScale(Math.min(newScale, 1.5)); // Maximum scale limit
    };

    useEffect(() => {
        window.addEventListener("resize", updateScale);
        updateScale();
        return () => window.removeEventListener("resize", updateScale);
    }, []);

    return (
        <div className="pdf-canvas-container" ref={containerRef}>
            <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.from(new Array(numPages), (el, index) => (
                    <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        scale={scale}
                        renderMode="canvas" // Ensures the PDF is rendered using a canvas
                        renderTextLayer={false}
                    />
                ))}
            </Document>
        </div>
    );
};

const DocumentViewer = ({ fileType, file }) => {
    if (fileType === "pdf") {
        return <RenderPDF file={file} />;
    }
    return null;
};

export default DocumentViewer;
